// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"_1deDiLTwTtRqXNOU_iOM3N","spaceLeft":"_2sEjoq2b0kpiANZTjSeDe_","spaceBoth":"_1IfRJCTeJfVFIyXir16H16","spaceRight":"_2GkAeWh8dyDAOsm1BjJxXt","LockedAccountSection":"_2uCE9Nbfk-hN9K0HejM7-6","OasisLogo":"_2w5YdtX2Qg0FVUzYaQ--Op","Separator":"_1l26idngISYSMNQpAmbdKN","Heading":"_2uLf2HivV68GDZRQRxqKn_","Message":"Oc9k7y5EB9UfxkntSEr3O","LogoContainer":"_3eSlW4n5AQhHfdNXQKGMOI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisYourNodeIsSyncing.scss
// module id = 1333
// module chunks = 0